import * as React from 'react';
import { SVGProps } from 'react';

const IconMicSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 3a1 1 0 0 1 2 0v3a1 1 0 0 1-2 0V3z" />
    <path d="M7 8.83V10H5V8.83A3.001 3.001 0 0 1 3 6h1a2 2 0 1 0 4 0h1a3.001 3.001 0 0 1-2 2.83z" />
  </svg>
);
export default IconMicSizeXs;
